import type { Education } from '@seek/ca-myprofile-utils';

import type { Action, ActionName } from 'src/types';
import type * as Schema from 'src/types/graphql';

export enum Actions {
  UPDATE_QUALIFICATION_START = 'UPDATE_QUALIFICATION_START',
  UPDATE_QUALIFICATION_SUCCESS = 'UPDATE_QUALIFICATION_SUCCESS',
  UPDATE_QUALIFICATION_FAILURE = 'UPDATE_QUALIFICATION_FAILURE',

  UPDATE_VERIFIED_QUALIFICATION_START = 'UPDATE_VERIFIED_QUALIFICATION_START',
  UPDATE_VERIFIED_QUALIFICATION_SUCCESS = 'UPDATE_VERIFIED_QUALIFICATION_SUCCESS',
  UPDATE_VERIFIED_QUALIFICATION_FAILURE = 'UPDATE_VERIFIED_QUALIFICATION_FAILURE',

  REMOVE_QUALIFICATION_START = 'REMOVE_QUALIFICATION_START',
  REMOVE_QUALIFICATION_SUCCESS = 'REMOVE_QUALIFICATION_SUCCESS',
  REMOVE_QUALIFICATION_FAILURE = 'REMOVE_QUALIFICATION_FAILURE',

  ADD_UNCONFIRMED_QUALIFICATION_START = 'ADD_UNCONFIRMED_QUALIFICATION_START',
  ADD_UNCONFIRMED_QUALIFICATION_SUCCESS = 'ADD_UNCONFIRMED_QUALIFICATION_SUCCESS',
  ADD_UNCONFIRMED_QUALIFICATION_FAILURE = 'ADD_UNCONFIRMED_QUALIFICATION_FAILURE',

  REJECT_UNCONFIRMED_QUALIFICATION_START = 'REJECT_UNCONFIRMED_QUALIFICATION_START',
  REJECT_UNCONFIRMED_QUALIFICATION_SUCCESS = 'REJECT_UNCONFIRMED_QUALIFICATION_SUCCESS',
  REJECT_UNCONFIRMED_QUALIFICATION_FAILURE = 'REJECT_UNCONFIRMED_QUALIFICATION_FAILURE',

  FETCH_CONFIRMED_QUALIFICATIONS_SUCCESS = 'FETCH_CONFIRMED_QUALIFICATIONS_SUCCESS',
  FETCH_UNCONFIRMED_QUALIFICATIONS_SUCCESS = 'FETCH_UNCONFIRMED_QUALIFICATIONS_SUCCESS',
}

export type EducationAction =
  | (Action<typeof Actions.FETCH_CONFIRMED_QUALIFICATIONS_SUCCESS> & {
      payload: Education[];
    })
  | (Action<typeof Actions.FETCH_UNCONFIRMED_QUALIFICATIONS_SUCCESS> & {
      payload: Education[];
    })
  | (Action<Actions.UPDATE_QUALIFICATION_START> & {
      payload: {
        updateQualificationInput: Schema.UpdateQualificationInput;
        action: ActionName;
      };
    })
  | Action<Actions.UPDATE_QUALIFICATION_SUCCESS>
  | (Action<Actions.UPDATE_QUALIFICATION_FAILURE> & {
      payload: { error: Error };
    })
  | Action<Actions.REMOVE_QUALIFICATION_START>
  | Action<Actions.REMOVE_QUALIFICATION_SUCCESS>
  | (Action<Actions.REMOVE_QUALIFICATION_FAILURE> & { payload: Error })
  | (Action<Actions.ADD_UNCONFIRMED_QUALIFICATION_START> & {
      payload: { id: string };
    })
  | Action<Actions.ADD_UNCONFIRMED_QUALIFICATION_SUCCESS>
  | (Action<Actions.ADD_UNCONFIRMED_QUALIFICATION_FAILURE> & {
      payload: Error;
    })
  | (Action<Actions.REJECT_UNCONFIRMED_QUALIFICATION_START> & {
      payload: { id: string };
    })
  | Action<Actions.REJECT_UNCONFIRMED_QUALIFICATION_SUCCESS>
  | (Action<Actions.REJECT_UNCONFIRMED_QUALIFICATION_FAILURE> & {
      payload: Error;
    })
  | Action<Actions.UPDATE_VERIFIED_QUALIFICATION_START>
  | Action<Actions.UPDATE_VERIFIED_QUALIFICATION_SUCCESS>
  | (Action<Actions.UPDATE_VERIFIED_QUALIFICATION_FAILURE> & {
      payload: { error: Error };
    });
